import { componentStyles } from "./toggle.scss";
import classnames from "classnames";
import { useState} from "react";

const Toggle =(props) => {
  const {handleToggle,
  toggleButtonColor,
  toggleBackgroundColor,
  leftPhrase,
  rightPhrase,
  swtichTextsColors
  } = props;

  const [isOn, setIsOn] = useState(false);

  const toggleSwitch =()=>{
    setIsOn(!isOn);
    handleToggle();
  }

  return (
      <div className={classnames("toggle", { on: isOn, "switch-texts-colors": swtichTextsColors })} onClick={toggleSwitch} style={{ "--background-color": toggleBackgroundColor, "--switch-color": toggleButtonColor }}>
        <div className="toggle-left">
          {leftPhrase}
        </div>
        <div className="toggle-right">
            {rightPhrase}
        </div>
        <style jsx>{componentStyles}</style>
      </div>
  );
};

export default Toggle;
